import {
  fetchRecruit,
  fetchPicAndVideo,
  fetchSuccess,
  fetchDepartment,
  fetchEmployee,
} from "@/api/index";

// 스토어가 아닌 모듈 변수라 새로고침하면 초기화된다.
// 같은 SPA 세션 안에서의 중복 호출만 걸러내기 위한 값이다.
let recruitFetchedAt = 0;
let recruitInflight = null;
const RECRUIT_FRESH_MS = 30 * 1000;

export const actions = {
  FETCH_RECRUIT: function (context) {
    const hasData = context.state.boardData && context.state.boardData.length > 0;

    if (hasData && Date.now() - recruitFetchedAt < RECRUIT_FRESH_MS) {
      return Promise.resolve();
    }
    if (recruitInflight) return recruitInflight;

    recruitInflight = fetchRecruit()
      .then((res) => {
        context.commit("SET_RECRUIT", res.data);
        recruitFetchedAt = Date.now();
      })
      .catch((err) => console.log(err))
      .then(() => {
        recruitInflight = null;
      });

    return recruitInflight;
  },

  FETCH_PIC_VIDEO: function (context) {
    fetchPicAndVideo()
      .then((res) => {
        context.commit("SET_PIC_VIDEO", res.data);
      })
      .catch((err) => console.log(err));
  },

  FETCH_SUCCESS: function (context) {
    fetchSuccess()
      .then((res) => {
        context.commit("SET_SUCCESS", res.data);
      })
      .catch((err) => console.log(err));
  },

  FETCH_DEPARTMENT: function (context) {
    fetchDepartment()
      .then((departmentRes) => {
        fetchEmployee()
          .then((employeeRes) => {
            context.commit("SET_DEPARTMENT", [
              departmentRes.data,
              employeeRes.data,
            ]);
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => console.log(err));
  },
};
